import { LOCALES, invoke, setLocale } from '@web3/utils';
import { useLocale } from '../../../../store/i18nMessage';
import { scTrack } from '../../../../utils/scTrack';

export type LanguageProps = {};

export function Language(_props: LanguageProps) {
  const { t, locale } = useLocale();

  const langItem = invoke(() => LOCALES.find((v) => v.value === locale));
  const select = (item: any) => {
    scTrack('Web3H5MoreSettingPageClick', {
      ...item,
      plate_area: 'Language',
    });
    setLocale(item.value);
  };

  return (
    <div className="mt-1">
      <div>{t('lang_chose')}</div>
      <ul className="sidebar-list mt-8">
        {LOCALES.map((item) => {
          return (
            <li key={item.value} onClick={() => select(item)}>
              {item.label}
              {langItem?.value === item.value && <div className="svg-full size-4 text-bds-brand-700-normal">{iconStar}</div>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const iconStar = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M17.304 1.524c-0.245-0.496-0.751-0.811-1.304-0.811s-1.059 0.314-1.304 0.811l-4.156 8.42-9.295 1.359c-0.548 0.080-1.003 0.464-1.173 0.991s-0.028 1.104 0.369 1.491l6.725 6.55-1.587 9.253c-0.094 0.546 0.131 1.097 0.579 1.423s1.042 0.368 1.532 0.111l8.312-4.371 8.312 4.371c0.49 0.258 1.084 0.215 1.532-0.111s0.672-0.877 0.579-1.423l-1.587-9.253 6.725-6.55c0.397-0.386 0.54-0.964 0.369-1.491s-0.626-0.911-1.173-0.991l-9.295-1.359-4.157-8.42z"></path>
  </svg>
);
